import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BottomNavbar from "../components/BottomNavbar";
import {
  fetchJurnalHarian,
  downloadJurnalHarian,
} from "../services/jurnalHarianService";

function JurnalHarian() {
  const navigate = useNavigate();
  const [jurnals, setJurnals] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [tanggalMulai, setTanggalMulai] = useState("");
  const [tanggalSelesai, setTanggalSelesai] = useState("");
  const [downloading, setDownloading] = useState(false);

  const siswaId = localStorage.getItem("user_id");

  useEffect(() => {
    const loadInitialData = async () => {
      if (!siswaId) return;
      setLoading(true);

      const response = await fetchJurnalHarian(siswaId, 1);
      if (response.success) {
        setJurnals(response.data.data);
        setHasMore(1 < response.data.last_page);
        setPage(1);
      } else {
        console.error(response.message);
      }
      setLoading(false);
    };

    loadInitialData();
  }, [siswaId]);

  const handleLoadMore = async () => {
    const nextPage = page + 1;
    setLoading(true);

    const response = await fetchJurnalHarian(siswaId, nextPage);
    if (response.success) {
      setJurnals((prev) => [...prev, ...response.data.data]);
      setHasMore(nextPage < response.data.last_page);
      setPage(nextPage);
    } else {
      console.error(response.message);
    }

    setLoading(false);
  };

  const handleDownload = async () => {
    if (!tanggalMulai || !tanggalSelesai) {
      alert("Tanggal mulai dan tanggal selesai wajib diisi.");
      return;
    }

    setDownloading(true);

    const result = await downloadJurnalHarian(
      siswaId,
      tanggalMulai,
      tanggalSelesai
    );

    setDownloading(false);

    if (result.success) {
      const url = window.URL.createObjectURL(new Blob([result.blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Jurnal_Harian.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      setShowModal(false);
    } else {
      alert(result.message);
    }
  };

  return (
    <div
      className="container"
      style={{ minHeight: "100vh", paddingBottom: "80px" }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center my-4">
        <div className="d-flex align-items-center">
          <button className="btn p-0" onClick={() => navigate(-1)}>
            ←
          </button>
          <h5 className="ms-3 mb-0 fw-bold">Riwayat Jurnal Harian</h5>
        </div>
        <button
          className="btn btn-primary"
          style={{
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            padding: 0,
          }}
          onClick={() => navigate("/input-jurnal")}
          title="Tambah Jurnal"
        >
          <i className="bi bi-plus-lg"></i>
        </button>
      </div>

      {/* Empty State */}
      {jurnals.length === 0 && !loading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "50vh" }}
        >
          <p className="text-muted mb-0">Tidak ada data jurnal.</p>
        </div>
      )}

      {/* Jurnal List */}
      <div className="list-group">
        {jurnals.map((jurnal) => (
          <div
            key={jurnal.id}
            className="mb-3 p-3"
            style={{
              backgroundColor: "#f1f4f9",
              borderRadius: "16px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <p className="fw-bold mb-2">
              {new Date(jurnal.tanggal).toLocaleDateString("id-ID", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })}
            </p>
            <p className="mb-1">
              <strong>Pekerjaan:</strong> {jurnal.pekerjaan}
            </p>
            {jurnal.catatan && (
              <p className="mb-0">
                <strong>Catatan:</strong> {jurnal.catatan}
              </p>
            )}
          </div>
        ))}
      </div>

      {/* Spinner */}
      {loading && (
        <div className="text-center my-3">
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}

      {/* Load More */}
      {!loading && hasMore && (
        <div className="text-center mt-3">
          <button className="btn btn-outline-primary" onClick={handleLoadMore}>
            Tampilkan Lebih Banyak
          </button>
        </div>
      )}

      {/* Download Button */}
      <button
        className="btn btn-primary position-fixed"
        style={{
          bottom: "100px",
          right: "20px",
          borderRadius: "16px",
          padding: "10px 16px",
          display: "flex",
          alignItems: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}
        onClick={() => setShowModal(true)}
      >
        <i className="bi bi-download me-2"></i> Download
      </button>

      {/* Modal */}
      {showModal && (
        <div
          className="modal d-block"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 9999,
            width: "100%",
            height: "100%",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Download Jurnal Harian</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Tanggal Mulai</label>
                  <input
                    type="date"
                    className="form-control"
                    value={tanggalMulai}
                    onChange={(e) => setTanggalMulai(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Tanggal Selesai</label>
                  <input
                    type="date"
                    className="form-control"
                    value={tanggalSelesai}
                    onChange={(e) => setTanggalSelesai(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Batal
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleDownload}
                  disabled={downloading}
                >
                  {downloading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Memproses...
                    </>
                  ) : (
                    "Download PDF"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <BottomNavbar />
    </div>
  );
}

export default JurnalHarian;
